var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat"},[_c('ChatHeader',{attrs:{"menu-sel":_vm.menuSel},on:{"on-menu-sel":function($event){_vm.menuSel = $event}}}),_c('ChatList',{attrs:{"items":_vm.chatItems,"all-msg":_vm.chatList,"username":_vm.username,"is-admin":_vm.isAdmin,"is-past":_vm.isPast,"title":"Архив чата трансляции"}}),_c('div',{staticClass:"empty-block"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }